//@flow

import styled from "styled-components"

const LocationName = styled.h3`
  font-size: 28px;
  font-family: "din-condensed";
  font-weight: 400;
  color: #fff;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 80%;
  margin: 0 1rem;
  padding: 0 3rem 0 0;
`

export default LocationName



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/LocationName.js